import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <g fillRule="nonzero">
      <path d="M8.785 17.568a8.755 8.755 0 0 1-6.212-2.573A8.754 8.754 0 0 1 0 8.784a8.754 8.754 0 0 1 2.573-6.211A8.755 8.755 0 0 1 8.785 0a8.755 8.755 0 0 1 6.212 2.573 8.754 8.754 0 0 1 2.573 6.211 8.754 8.754 0 0 1-2.573 6.211 8.755 8.755 0 0 1-6.212 2.573zm0-16.79a7.966 7.966 0 0 0-5.662 2.344 8.003 8.003 0 0 0-1.716 2.545 7.946 7.946 0 0 0-.629 3.117 7.978 7.978 0 0 0 2.345 5.662 7.985 7.985 0 0 0 5.662 2.344 7.98 7.98 0 0 0 5.662-2.344 7.955 7.955 0 0 0 1.716-2.545 7.946 7.946 0 0 0 .629-3.117 7.978 7.978 0 0 0-2.345-5.662 7.956 7.956 0 0 0-2.545-1.715A7.949 7.949 0 0 0 8.785.778z" />
      <path d="M12.886 10.624s-.277.754-.787 1.432c0 0 .91.309.834 1.11 0 0 .03.892-1.945.83 0 0-1.388-.106-1.805-.692h-.367c-.416.586-1.804.693-1.804.693-1.975.062-1.944-.832-1.944-.832-.077-.8.833-1.109.833-1.109a6.379 6.379 0 0 1-.787-1.432c-1.234 1.986-1.11-.278-1.11-.278.23-1.34 1.203-2.217 1.203-2.217-.139-1.216.37-1.433.37-1.433C5.683 2.932 8.932 2.998 9 3c.068-.001 3.316-.068 3.423 3.696 0 0 .51.216.37 1.433 0 0 .972.878 1.203 2.217.001 0 .124 2.264-1.11.278z" />
    </g>
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./src/asset/icon/qq.svg